// strings should be unique across reducers so namespace them with the reducer name
export const COMMON_NEED_TO_CHECK_AUTH = 'common.NEED_TO_CHECK_AUTH';
export const COMMON_DISMISS_ALL_CHECKS = 'common.DISMISS_ALL_CHECKS';

export const COMMON_SHOW_INFO_ALERT = 'common.SHOW_INFO_ALERT';
export const COMMON_HIDE_INFO_ALERT = 'common.HIDE_INFO_ALERT';